import { DownloadService } from "./../../services/download.service";
import { Component, OnInit, AfterViewChecked, ViewChild } from "@angular/core";
import { Location, DecimalPipe, DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { DialogService } from "../../services/dialog.service";

import { UploadCarga } from "../../model/domain/UploadCarga";
import { TicketService } from "../../services/ticket.service";
import { SnackbarService } from "../../services/snackbar.service";
import { LoaderService } from "../../services/loader.service";
import { UploadService } from "../../services/tickets/Upload.service";
import { DateTime } from "luxon";

@Component({
  selector: "app-upload-carga",
  templateUrl: "./upload-carga.component.html",
  styleUrls: ["./upload-carga.component.css"],
})
export class UploadCargaComponent implements OnInit, AfterViewChecked {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private dialogService: DialogService,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService,
    private uploadService: UploadService,
    private downloadService: DownloadService
  ) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  isEditing = false;
  canValidate = false;
  isReady = false;
  ngForm: NgForm;
  AccountManagers = [];
  fileList: File[] = [];
  file: File;
  model: UploadCarga;

  afuConfig = null;

  validators = {};

  // Init
  ngOnInit() {
    this.validatorsInit();
    this.modelInit();
  }

  ngAfterViewChecked() {
    if (!this.isReady) {
      setTimeout(() => {
        if (!this.canEdit()) {
          Object.values(this.frm.controls).forEach((c) => {
            c.disable();
          });
        }
      }, 0);
      this.isReady = true;
    }
  }

  validatorsInit() {
    // Add validators
  }

  modelInit() {
    this.model = new UploadCarga();
    this.model.loadTypesId = null;
  }

  canEdit() {
    return true;
  }

  validateForm(f: NgForm): boolean {
    return true;
  }

  submit() {
    this.loaderService.addLoader();

    const editing = this.isEditing;

    this.register(this.frm)
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe(
        (r) => {
          this.loaderService.removeLoader();
        },
        () => {}
      );
  }

  register(f: NgForm) {
    const editing = this.isEditing;

    if (!this.canEdit()) {
      return;
    }

    try {
      const isValid = this.validateForm(f);
      if (isValid) {
        let data = Object.assign({}, this.model);

        return this.sendSubmit(data, editing);
      }
    } catch (error) {
      return throwError(error);
    }
  }

  openFile(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.file = this.fileList[0];
    }
  }

  sendSubmit(data: UploadCarga, editing: boolean = false) {
    data.fileBase64 = this.file;
    data.loadTypesId = this.model.loadTypesId;
    const method = this.uploadService.uploadCarga(data);

    return method
      .pipe(
        catchError((err) => {
          if (err.error == "Envie sua planilha no formato adequado.") {
            this.snackBarService.open(
              "Envie sua planilha no formato adequado",
              "OK",
              {
                verticalPosition: "top",
                horizontalPosition: "right",
              }
            );
            return throwError("Envie sua planilha no formato adequado.");
          }
          if (err.error == "Envie ao menos uma boleta preenchida") {
            this.snackBarService.open(
              "Envie ao menos uma boleta preenchida",
              "OK",
              {
                verticalPosition: "top",
                horizontalPosition: "right",
              }
            );
            return throwError("Envie ao menos uma boleta preenchida.");
          } else {
            this.snackBarService.open(
              "Erro ao fazer upload da(s) carga(s).",
              "OK",
              {
                verticalPosition: "top",
                horizontalPosition: "right",
              }
            );
            this.dialogService.modalerrorcarga(
              err.error,
              this.model.loadTypesId
            );
            return throwError("Erro ao fazer upload da(s) carga(s).");
          }
        })
      )
      .pipe(
        map((result) => {
          if (result != null) {
            this.snackBarService.open(
              "Erro ao fazer upload da(s) carga(s).",
              "OK",
              {
                verticalPosition: "top",
                horizontalPosition: "right",
              }
            );
            return this.dialogService.modalerrorcarga(
              result,
              this.model.loadTypesId
            );
          } else {
            window.location.reload();
            this.snackBarService.open("Carga(s) cadastrada(s).", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return this.model;
          }
        })
      );
  }

  downloadTemplate() {
    this.loaderService.addLoader();
    const method = this.uploadService.downloadTemplate(this.model.loadTypesId);

    return method.subscribe(
      (data: Blob) => {
        const filename = `export_${DateTime.local().toFormat("yyyyMMdd")}.xlsx`;
        this.downloadService.downloadFile(data, filename);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível baixar o template. Tente novamente mais tarde",
          "OK"
        );
      }
    );
  }
}
